module.exports = __webpack_public_path__ + "static/media/电伴热系统图_03.20df0f82.png";